import { styled } from "styled-components";

import { ExpandableContent } from "common/components";
import { AutocompleteOptionTag } from "common/components/form/Autocomplete/AutocompleteOptionTag";

type SuggestedTopicsOption = {
  id: string;
  name: string;
};

type SuggestedTopicsProps = {
  suggestedTopics?: SuggestedTopicsOption[];
  isDisabled?: boolean;
  onSuggestionPress: (item: SuggestedTopicsOption) => void;
};

export const SuggestedTopics = ({ suggestedTopics, isDisabled, onSuggestionPress }: SuggestedTopicsProps) => {
  if (!suggestedTopics) return null;

  return (
    <ExpandableContent isActive={suggestedTopics.length !== 0}>
      <StyledTagContainer hasTags={suggestedTopics.length !== 0}>
        {suggestedTopics.map((item) => (
          <AutocompleteOptionTag
            key={`unselected-tag-${item.id}`}
            label={item.name}
            dataTestId="add-custom-key-issue-connected-map-selector-suggestion-tag"
            disabled={isDisabled}
            onClick={() => onSuggestionPress(item)}
          />
        ))}
      </StyledTagContainer>
    </ExpandableContent>
  );
};

const StyledTagContainer = styled.div<{ hasTags: boolean }>`
  transition: margin-bottom 0.3s;
  margin-bottom: ${({ hasTags }) => (hasTags ? "calc(1rem - 10px)" : "1rem")};
`;
